<template>
<div>
  <div class="detailsTitle" >
      <div class="printBox">
        <h4>打印车辆信息</h4>
        <el-button type="primary" @click="dayinFN" size="mini">打印</el-button>
      </div>
       <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
  <div id="wrap" class="printBox">
      <div  style="page-break-after:always">
          <h2>运输车辆电子台账信息表</h2>

          <table border="1" cellpadding="0" cellspacing="0" style="width:850px;" width="850">
            <thead >
              <tr >
                <td width="100">名称</td>
                <td>进厂时间</td>
                <td width="300">出厂时间</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>进出厂时间</td>
                <td>{{listData.enterTime | dataFormatA('time')}} </td>
                <td>{{listData.inOutTime | dataFormatA('time')}} </td>
              </tr>
              <tr>
                <td>照片</td>
                <td> <img referrerpolicy="no-referrer" v-if="carimage!=''" :src="carimage"  style="width:320px;height:200px">
                </td>
                <td><img referrerpolicy="no-referrer"  v-if="outcarimage!=''" :src="outcarimage"  style="width:320px;height:200px"></td>
              </tr>
              <tr>
                <td>车牌号</td>
                <td colspan="2">{{listData.vhcNo}}</td>

              </tr>
              <tr>
                <td>注册日期</td>
                <td colspan="2">{{listData.registerDate|dataFormatA}} </td>
              </tr>
              <tr>
                <td>车辆识别代号(VIN)</td>
                <td colspan="2">{{listData.vhcVinNo}}</td>

              </tr>
              <tr>
                <td>发动机号码</td>
                <td colspan="2">{{listData.vhcEngineNo}}</td>

              </tr>
              <tr>
                <td>排放阶段</td>
                <td colspan="2">{{listData.standardsName}}</td>
<!--
                <td>国0:0;国1:1;国2:2;国3:3;国4:4;国5:5;国6:6;电动：D;</td>
-->
              </tr>
              <tr>
                <td>随车清单</td>
                <!-- <td colspan="2" >{{listData.boardList}}</td> -->

                <td> <img v-if="vhcPhoto2!=''" :src="vhcPhoto2"  style="width:320px;height:200px"></td>
              </tr>
              <tr>
                <td>行驶证</td>
                <!-- <td colspan="2">{{listData.drivingLicense}}</td> -->
                 <td> <img v-if="vhcPhoto1!=''" :src="vhcPhoto1"  style="width:320px;height:200px">
                </td>
              </tr>
               <!-- <tr>
                <td>运输货物名称</td>
                <td colspan="2">{{listData.ext1?listData.ext1:listData.purposeName}}</td>
              </tr> -->
              <tr>
                <td>运输量</td>
                <td colspan="2">{{listData.weight}}</td>
              </tr>
              <tr>
                <td>供应商</td>
                <td colspan="2">{{listData.provider}}</td>
              </tr>
              <tr>
                <td>收货单位</td>
                <td colspan="2">{{listData.receiveUnit}}</td>
              </tr>
              <tr>
                <td>物料信息</td>
                <td colspan="2">{{listData.materielName}}</td>
              </tr>
               <tr>
                <td>车队名称(自有，个人，运输公司营业执照)</td>
                <td colspan="2">{{listData.vhcCompanyName}}</td>
              </tr>
            </tbody>
          </table>
          <ul class="dibu">
            <li>打印人：{{userName}}</li>
            <!-- <li>制单人：{{listData.createUserName}}</li> -->
             <li>打印日期：{{date|dateFormat}}</li>
            <li></li>

          </ul>
          <div class="noPrint "></div>
      </div>
  </div>
</div>
</template>

<script>
import { getDriverStandingBookPage, urlChangeBase64 } from '@/api/vgs-driver'
export default {
  data () {
    var id = this.$route.query.id
    return {
      id: id,
      vDistribution: {},
      listData: {},
      date: '',
      userName: '',
      carimage: '',
      outcarimage: '',
      vhcPhoto1: '',
      vhcPhoto2: ''

    }
  },
  created () {
    this.list = []
    getDriverStandingBookPage({ id: this.id, pageNo: 1, pageSize: 50 }).then(res => {
      this.listData = res.list[0]
      if (this.listData.enterImg) {
        urlChangeBase64({ imageUrl: this.listData.enterImg }).then(res1 => {
          this.carimage = 'data:image/jpeg;base64,' + res1
        })
      }
      if (this.listData.outImg) {
        urlChangeBase64({ imageUrl: this.listData.outImg }).then(res1 => {
          this.outcarimage = 'data:image/jpeg;base64,' + res1
        })
      }
      this.vhcPhoto1 = this.listData.vhcPhoto1
      this.vhcPhoto2 = this.listData.vhcPhoto2
    })
    this.date = new Date().getTime()
    this.userName = localStorage.getItem('userName')
  },
  mounted () {
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    dayinFN () {
      var that = this
      this.date = new Date().getTime()
      Print('#wrap', {
        onStart: function () {
          console.log('onStart', new Date())
        },
        onEnd: function () {
          console.log(that.ids)
          // VSPupdateList({ ids: that.ids }).then(res => {
          // })
        }
      })
    }
  },
  filters: {
    dataFormatA (data, type) {
      var t = new Date(data) // row 表示一行数据, transferTime 表示要格式化的字段名称
      let year = t.getFullYear()
      var month = t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (data == null || data == '') {
        str = '--'
      } else {
        if (type == 'time') {
          str = year + month.toString() + date + ' ' + hour + minutes + seconds
        } else {
          str = year + month.toString() + date
        }
      }
      return str
    }
  }
}
</script>

<style scoped lang='less'>
.printBox{
  width: 1000px;
  h2{
    width: 50%;
    text-align: center;
    margin: 0 auto;
    padding: 50px;
    padding-top: 80px;
    font-size: 40px;
  }
  table{
    width: 90%;
    height: 70%;
    margin: 0 auto;
    td{
      padding: 4px 10px;
      text-align: center;
      height:28px;
    }
  }
  .toubu{
    display: flex;
    justify-content:space-between;
    padding: 0;
    padding-right: 10px;
    margin: 4px;

  }
  li{
        list-style: none;
  }
  .dibu{
    display: flex;
    justify-content:space-between;
    padding: 0;
    width:850px;
    margin: 0 auto;
    margin-top: 6px;
    li:last-child{
      padding-right: 40px;
      padding-right: 112px;
    }
  }
  .noPrint{
    width: 100%;
    height: 40px;
  }
}
</style>
